import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Paging from '../../component/Paging';
import request from '../../../utils/Request.utils';
import { ToastContainer, toast } from 'react-toastify';
import Modal from '../../component/Modal';

const Consult = ({ isLoggedIn }) => {
  const navigate = useNavigate();
  const [consults, setConsults] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currPage, setCurrPage] = useState(1);
  const [totalCnt, setTotalCnt] = useState(0);
  const [loading, setLoading] = useState(true);

  // 상태
  const [consuStatList, setConsuStatList] = useState([]);

  // 선택된 항목
  const [selectedConsults, setSelectedConsults] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);


  const getConsuStat = () => {
    let params = {};

    const successHandler = (response) => {
      if (response.messageCode === 200) {
        setConsuStatList(response.data.data_list);
      } else {
        console.log("상담 상태정보를 불러올 수 없습니다.");
        toast.error("상담 상태정보를 불러올 수 없습니다.");
      }
    };
    const failHandler = (error) => {
      console.log(error);
    };

    request.get("/common/code/consu_stat", params, successHandler, failHandler);
  };

  const successHandler = useCallback((response) => {
    if (response.messageCode === 200) {
      const data = response.data || {};
      setConsults(Array.isArray(data.dataList) ? data.dataList : []);
      setTotalPages(Number(data.tot_page) || 0);
      setTotalCnt(Number(data.totalCnt) || 0);
      setSelectedConsults([]);
      setLoading(false);
    } else {
      toast.error("문의사항 정보를 불러올 수 없습니다.");
      setLoading(false);
    }
  }, []);

  const errorHandler = useCallback((error) => {
    toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
    setLoading(false);
  }, []);

  const fetchConsults = useCallback(() => {
    setLoading(true);
    const params = {
      curr_page: currPage,
      per_page: 10,
      sort_col: 'reg_dtm',
      sort_by: 'desc',
      consu_stat: 'all',
    };
    request.get("/board/list/admin/consult", params, successHandler, errorHandler);
  }, [currPage, successHandler, errorHandler]);

  useEffect(() => {
    fetchConsults();
  }, [fetchConsults, currPage]);

  useEffect(() => {
    getConsuStat();
  }, []);

  const handlePageChange = (page) => {
    setCurrPage(page);
  };

  const handleSelectConsult = (consultId) => {
    setSelectedConsults(prevSelectedConsults =>
      prevSelectedConsults.includes(consultId)
        ? prevSelectedConsults.filter(id => id !== consultId)
        : [...prevSelectedConsults, consultId]
    );
  };

  const handleSelectAll = () => {
    if (consults.length === 0) {
      setSelectedConsults([]);
      return;
    }

    if (selectedConsults.length === consults.length) {
      setSelectedConsults([]);
    } else {
      setSelectedConsults(consults.map(consult => consult.consu_seq));
    }
  };

  const openModal = () => {
    if (selectedConsults.length === 0) {
      toast.error("삭제할 상담 신청을 선택해 주세요.");
      return;
    }
    setModalIsOpen(true);
  };
  const closeModal = () => setModalIsOpen(false);

  const handleDelete = async () => {
    if (selectedConsults.length === 0) {
      toast.error("삭제할 상담 신청을 선택해 주세요.");
      closeModal();
      return;
    }

    try {
      await request.del("/board/consult", { consu_seqs: selectedConsults }, () => {
        toast.success("상담요청이 성공적으로 삭제되었습니다.");
        fetchConsults();
        setSelectedConsults([]);
      }, () => {
        toast.error("상담요청 삭제 중 오류가 발생했습니다.");
      });
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">상담 신청 목록</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_btn_wrap">
          <button className="adm_com_btn gray" onClick={openModal} disabled={consults.length === 0}>선택삭제</button>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className='adm_com_board_list adm_consult_list'>
            <colgroup>
              <col width="4%" />
              <col width="5%" />
              <col width="14%" />
              <col width="12%" />
              <col width="13%" />
              <col width="8%" />
              <col width="8%" />
              <col width="10%" />
              <col width="12%" />
              <col width="14%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <div className="check">
                    <input
                      type="checkbox"
                      id="chk01"
                      className="adm_com_chk"
                      onChange={handleSelectAll}
                      checked={consults.length > 0 && selectedConsults.length === consults.length}
                      disabled={consults.length === 0}
                    />
                    <label htmlFor="chk01" />
                  </div>
                </th>
                <th>번호</th>
                <th>회사명</th>
                <th>이름/직책</th>
                <th>전화번호</th>
                <th>상태</th>
                <th>메모여부</th>
                <th>상담자</th>
                <th>작성일자</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {consults.length === 0 && (
                <tr>
                  <td colSpan={10}>등록된 상담 신청이 없습니다.</td>
                </tr>
              )}
              {consults.map((consult, index) => (
                <tr key={consult.consu_seq}>
                  <td>
                    <div className="check">
                      <input
                        type="checkbox"
                        id={`chk${index + 2}`}
                        className="adm_com_chk"
                        checked={selectedConsults.includes(consult.consu_seq)}
                        onChange={() => handleSelectConsult(consult.consu_seq)}
                      />
                      <label htmlFor={`chk${index + 2}`} />
                    </div>
                  </td>
                  <td>{totalCnt - ((currPage - 1) * 10 + index)}</td>
                  <td className="td_ellipsis" title={consult.consu_corp}>
                    {consult.consu_corp}
                  </td>
                  <td className="td_ellipsis" title={consult.consu_name}>{consult.consu_name}</td>
                  <td className="td_ellipsis" title={consult.consu_tel}>{consult.consu_tel}</td>
                  <td className={consult.consu_stat === 'CON_ST03' ? 'td_green bold' : 'td_red'}>
                    {consult.consu_stat && consuStatList.find(a => a.comm_code === consult.consu_stat) ? consuStatList.find(a => a.comm_code === consult.consu_stat).code_nm : '접수중'}
                  </td>
                  <td className={consult.manger_memo ? 'td_green bold' : 'td_red'}>
                    {consult.manger_memo ? 'Y' : 'N'}
                  </td>
                  <td className="td_ellipsis" title={consult.author || '관리자'}>{consult.author || '관리자'}</td>
                  <td>{new Date(consult.reg_dtm).toLocaleDateString()}</td>
                  <td>
                    <button onClick={() => navigate(`/Manage/Consult/Write/${consult.consu_seq}`)} className="adm_com_btn blue line">상담관리</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {totalPages > 0 && <Paging currentPage={currPage} totalPages={totalPages} onPageChange={handlePageChange} />}
      </div>
      <Modal
        open={modalIsOpen}
        close={closeModal}
        type="confirm"
        popSize="s"
        title="삭제 확인"
        description="선택된 상담신청을 삭제하시겠습니까?"
      >
        <div className="btn_container">
          <button className="adm_com_btn blue" onClick={handleDelete}>삭제</button>
          <button className="adm_com_btn gray" onClick={closeModal}>취소</button>
        </div>
      </Modal>

      <ToastContainer />
    </main>
  );
};

export default Consult;
